// src/app/jobs/job-search-card/job-search-card.component.ts
import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { JobPositionPublicDto } from '@/app/models/public';

@Component({
  selector: 'app-job-search-card',
  templateUrl: './job-search-card.component.html',
  imports: [
    RouterLink,
    MatButtonModule,
  ],
})
export class JobSearchCardComponent {
  job = input.required<JobPositionPublicDto>();

  slug = computed(() => this.job().job?.matchedLeadsProduct?.slug ?? null);

  title = computed(() => this.job().job?.title ?? 'Untitled Position');

  companyName = computed(() => this.job().job?.matchedLeadsProduct?.name ?? null);

  logoUrl = computed(() => this.job().job?.matchedLeadsProduct?.company?.imageUrl ?? null);

  location = computed(() => {
    const city  = this.job().city ?? '';
    const state = this.job().hiringState?.abbreviation ?? this.job().state ?? '';
    return [city, state].filter(Boolean).join(', ');
  });

  salary = computed(() => this.job().salary ?? this.job().job?.salary ?? null);

  cdl = computed(() => {
    const classes = this.job().job?.cdlClasses;
    return classes?.length ? classes.map(c => c.name).join(', ') : null;
  });

  driverType = computed(() => {
    const types = this.job().job?.driverTypes;
    return types?.length ? types.map(t => t.name).join(', ') : null;
  });

  experience = computed(() => {
    const job = this.job().job;
    if (job?.customExperienceLevels && job?.customExperienceTypes?.length) {
      return job.customExperienceTypes.map(e => e.name).join(', ');
    }
    if (job?.experienceType?.name) {
      return job.experienceType.name + ' min.';
    }
    return null;
  });

  freightType = computed(() => {
    const types = this.job().job?.freightTypes;
    return types?.length ? types.map(t => t.name).join(', ') : null;
  });
}
